import { render, staticRenderFns } from "./goBack.vue?vue&type=template&id=ffed013e&scoped=true"
import script from "./goBack.vue?vue&type=script&lang=js"
export * from "./goBack.vue?vue&type=script&lang=js"
import style0 from "./goBack.vue?vue&type=style&index=0&id=ffed013e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffed013e",
  null
  
)

export default component.exports